export const EDIT_LOCATION = "EDIT_LOCATION";

export const editLocation = (data: any) => ({ type: EDIT_LOCATION, payload: data })

